const LeftArea = () => {
  return <div style={{ backgroundColor: "white", width: "10%" }}></div>;
};

export default LeftArea;
